import React, { useContext } from "react";
import Navbar from "../Home/Navbar";
import Footer from "../Home/Footer";
import { Link, useParams } from "react-router";
import { apiValue } from "../Data/AllData";
import { CartProvider, useCart } from "react-use-cart";


function Page(){
  const {addItem} = useCart();
  const { id } = useParams();
  const api = useContext(apiValue);
  return(
    <div>
      {api.map((element) => {
        return element.id == id ? (
          <section className="bg-light" key={element.id}>
            <div className="container pb-5">
              <div className="row">
                <div className="col-lg-5 mt-5">
                  <div className="card mb-3">
                    <img
                      className="card-img img-fluid"
                      src={element.images[0]}
                      alt={element.title}
                      id="product-detail"
                    />
                  </div>
                </div>

                <div className="col-lg-7 mt-5">
                  <div className="card">
                    <div className="card-body">
                      <h1 className="h2 text-success mb-3">{element.title}</h1>
                      <p className="h3 ">
                        <b>${element.price}</b>
                      </p>
                      <p>
                        <span className="list-inline-item text-dark">
                          <b>Id :</b> {element.id} 
                        </span>
                      </p>
                      <p>
                        <span className="list-inline-item text-dark">
                          <b>Rating :</b> {element.rating} of 5
                        </span>
                      </p>
                      <ul className="list-inline">
                        <li className="list-inline-item">
                          <h6>Brand :</h6>
                        </li>
                        <li className="list-inline-item">
                          <p>{element.brand}</p>
                        </li>
                      </ul>
                      <h6>Description :</h6>
                      <p>{element.description}</p>
                      <ul className="list-inline">
                        <li className="list-inline-item">
                          <h6>Stock :</h6>
                        </li>
                        <li className="list-inline-item">
                          <p>{element.stock}</p>
                        </li>
                      </ul>

                      <div className="row pb-3">
                        <div className="col d-grid">
                          <Link
                            to="/shop"
                            className="btn btn-secondary btn-lg"
                          >
                            Back to shopping
                          </Link>
                        </div>
                        <div className="col d-grid">
                          <button
                            onClick={() => addItem(element)}
                            className="btn btn-success btn-lg"
                          >
                            Add To Cart
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : null;
      })}
    </div>
    
    );

};


function AllShopSingle() {
  return (
    <CartProvider>
      <Navbar />
      <br />
      <br />
      <br />
      <Page/>
      <Footer />
    </CartProvider>
  );
}

export default AllShopSingle;
